import ServiceCard from "./ServiceCard";
import BPOImg from "../../assets/bpo-example.png";
import EAFImg from "../../assets/generated_images/address-finder.png";
import DevImg from "../../assets/generated_images/web-development.png";

import BPOService from "../../assets/bpo_draft-edit.png"

const services = [
  {
    title: "BPO Services",
    desc: "Streamline operations with our comprehensive business process outsourcing solutions. <br> Service offerings include <strong>AI Engineers</strong>, <strong>Web Developers</strong>, <strong>Quality Assurance</strong> personnel, <strong> Database Administrators</strong> and <strong>Pharmacists</strong>",
    image: BPOService,
    url: "/bpo"
  },
  {
    title: "Enhanced Address Finder",
    desc: "Advanced data analytics, geolocation, and business intelligence tools.<br> Get your <strong>Unique Property Reference Number (UPRN)</strong>, Precise <strong>geo coordinates</strong>, <strong>latitude</strong> and <string>longitude</strong> and <strong>£ property valuation</strong>.",
    image: EAFImg,
    url: "/address-finder"
  },
  {
    title: "Web & Mobile Development",
    desc: "A team of Web Developers with extensive knowledge of all main applications including <strong>.Net, C#, Php, Python, MS SQL, JS, Angular, ReactJS, CSS, dHTML, JSON, XML, web services </strong> and <strong> APIs </strong> covering <strong> web, desktop, mobile </strong> and app platforms using collaboration tools in <strong> Azure DevOps, Jira, GitHub, SVN </strong> and others.",
    image: DevImg,
    url: "/web-development"
  },
];

export default function ServicesSection() {
  return (
     <section className="relative overflow-hidden bg-white py-20">
        {/* Background shape */}
        <div className="pointer-events-none absolute -top-32 -right-48 h-[520px] w-[520px] rounded-full bg-gray-100" />

        <div className="relative z-10 max-w-7xl mx-auto px-6">
            {/* Header */}
            <div className="text-center max-w-2xl mx-auto">
            <h2 className="text-3xl font-bold text-gray-900">Our Services</h2>
            <p className="mt-4 text-gray-600">
                Comprehensive technology solutions tailored to meet your business needs
                and drive digital transformation.
            </p>
            </div>

        {/* Cards */}
        <div className="mt-12 grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {services.map((s) => (
            <ServiceCard key={s.title} {...s} />
          ))}
        </div>
      </div>
    </section>
  );
}
